import { Grid, Paper, Typography, IconButton } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { KILL_UPLOAD_CWK } from "config/CONSTANTS";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getManagerEmails,
  getJobFamilies,
  getWOrkdayConfig,
} from "../../redux/actions/appActions";
import VerticalTabsComponent from "./Tabs/VerticalTabsComponent";
import HorizontalTabsComponent from "./Tabs/HorizontalTabsComponent";
import { Box } from "@mui/material";
//import SectionHead from "components/SectionHead";
import Alert from "@mui/lab/Alert";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { properCase } from "utils";
//import SectionHead from "./SectionHead/SectionHeadEdit";
import {getWorkerDetailsWithRoles, resetWorkerDetails} from "../../redux/actions/addEditWorker";
import { getCountryDetails } from "services";
import { getCountriesSuccess } from "redux/actions/appActions";
import { useHistory } from "react-router-dom";
import { isEmptyObject } from "utils/index";
import { ArrowBack} from "@mui/icons-material"

export const AddEditWorkerContainer = (props) => {
  const history = useHistory();
  const { t } = useTranslation();
  const location = useLocation();
  const appConfig = useSelector((state) => state.appConfig);
  const imtRole = useSelector((state) => state.user.imtRole || null)
  const dispatch = useDispatch();
  const [showUpload, setShowUpload] = useState(true);
  const theme = useTheme();
  const worker = location.state && location.state.worker ? location.state.worker : null;
  const [readOnly, setReadOnly] = useState(false);

  useEffect(() => {
    if (appConfig !== null) {
      if (appConfig.managerEmails == null) {
        dispatch(getManagerEmails());
      }
      if (
        appConfig.workdayConfig &&
        !Object.keys(appConfig.workdayConfig).length > 0
      ) {
        dispatch(getWOrkdayConfig());
      }
      if (appConfig && appConfig.countries == null) {
          getCountryDetails().then((data) => {
            if (data) {
              dispatch(getCountriesSuccess(data));
            }
          });
        }
    }
    if (appConfig && !appConfig.jobFamilies) {
      dispatch(getJobFamilies());
    }
    if(worker && worker.workerId){
      dispatch(getWorkerDetailsWithRoles(worker.workerId))
    }
    return (( ) => {
      dispatch(resetWorkerDetails())
    })
  }, []);

  useEffect(() => {
      if(imtRole?.userRole?.role === "Support"){
        setReadOnly(true)
      }
  },[imtRole])

  // VERTICAL TABS
  return (
    <>
      <Paper style={{marginTop:'20px'}}>
         <Grid container style={{padding: '10px', alignItems:'center', width:'100%' }} direction="row">
                <Grid item>
                  <IconButton aria-label="back" onClick={() => {history.goBack()}}>
                    <ArrowBack fontSize="medium" />
                  </IconButton>
                </Grid>
                <Grid item>
                  <Typography style={{paddingLeft: 3}} variant="h5" color="primary">
                    {isEmptyObject(worker) ?
             properCase(t("pgAddWorker.lblAddContingentWorker")) :
             properCase(t("pgAddWorker.lblEditContingentWorker"))}
                  </Typography>
                </Grid>
                {/* {readOnly ? 
                  <Grid item style={{marginLeft: 'auto'}}>
                    <Typography variant="h6" color="error">
                      You have read-only access. No changes are allowed.
                    </Typography>
                  </Grid>
                  : ""} */}
          </Grid>
        <hr id="customHr3"/>
        <VerticalTabsComponent />
      </Paper>
    </>
  );
};

AddEditWorkerContainer.propTypes = {};

export default AddEditWorkerContainer;
